<template>
  <div>
    <banner
      :title="myTitle"
      :paths="[{ label: '产品中心', url: '/productp' }]"
    ></banner>

    <div class="list">
      <div class="l-title">
        <span>
          <b>{{ myTitle }}</b>
        </span>
      </div>
      <productList></productList>
      <div class="wrap piclist prolist">
        <div class="container-fluid">
          <div class="row" style="margin: 0">
            <div
              class="col-md-3 col-sm-6 col-12"
              v-for="(image, index) in list"
              :key="index"
              style="box-sizing: border-box"
            >
              <a @click="jump(image)"
                ><div class="item" style="box-sizing: border-box">
                  <p class="xian-hx"></p>
                  <p class="xian-sx"></p>
                  <div class="pic">
                    <img :src="image.img" :alt="image.label" />
                  </div>
                  <div class="txt">
                    <p class="t1 ellipsis">{{ image.label }}</p>
                    <br />
                    <span></span>
                  </div></div
              ></a>
            </div>
          </div>
          <div class="de-page-mian"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../../components/banner.vue";
import common from "./common.js";
import productList from "@/components/productList.vue";
export default {
  components: {
    banner,
    productList,
  },
  data() {
    return {
      imageList: common,
    };
  },
  computed: {
    list() {
      let type = this.$route.query.type;
      let list = this.imageList.filter((item) => item.type == type);
      return list;
    },
    myTitle() {
      let type = this.$route.query.type;
      let list = this.imageList.filter((item) => item.type == type);
      return list.length > 0 ? list[0].label : "产品中心";
    },
  },
  methods: {
    jump(imgae) {
      this.$router.push({
        path: "/proinfo",
        query: {
          type: imgae.type,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lightbox {
  .item {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden;
    transition: all 0.5s;
    border: solid 1px #eee;
    .pic {
      width: 100%;
      height: 250px;
      position: relative;
      overflow: hidden;
      &:after {
        width: 0;
        height: 0;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.5s;
        border-radius: 50%;
      }
      img {
        width: 95%;
        height: 100%;
        object-fit: contain;
        position: absolute;
      }
      i {
        color: #fff;
        font-size: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        opacity: 0;
        transition: all 0.5s;
      }
    }
    .txt {
      background: #f6f5f5;
      padding: 15px;
      transition: all 0.5s;
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    &:hover {
      box-shadow: 0 0 10px #999;
      i {
        opacity: 1;
      }
      .pic:after {
        width: 200%;
        height: 200%;
        left: -50%;
        top: -50%;
      }
      // .txt {
      //   background: @primaryColor;
      //   color: #fff;
      // }
    }
  }
}

.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
</style>
